import React from 'react';
import roadmap from '../../../../assets/images/lending/roadmap/roadmap.png';
import styles from './styles.module.scss';

export const RoadmapPic = () => (
  <div className={styles.container}>
    <img className={styles.roadmap} src={roadmap} alt='roadmap' />
  </div>
);
